import React from "react";

const OrgCellRenderer = (props: any) => {
    const onClickOrg = () => {
        if (props.context) {
            props.context.onClickOrg(props.data);
        }
    }
    return (
        <div className={"cellRenderHeader"}>
            <a><span onClick={onClickOrg} className={"cellRender"}>{props.value}</span></a>
        </div>

    )
}

export default OrgCellRenderer;